module.exports = __webpack_public_path__ + "static/img/submitted.703df605.png";